import * as React from 'react';
import {theme} from '../style';

interface CalloutArrowProps {
  from: {x: number; y: number};
  to: {x: number; y: number};
  // how much you would like the line to deviate from being straight
  delta: {x: number; y: number};
}

/**
 * Draw a curved arrow pointing from and to coordinates on the svg in absolute x/y space.
 */
export class CalloutArrow extends React.Component<CalloutArrowProps> {
  static getDefinitions() {
    return (
      <marker
        id="open-arrowhead"
        markerWidth="6"
        markerHeight="6"
        viewBox="-3 -3 6 6"
        refX="-1"
        refY="0"
        markerUnits="strokeWidth"
        orient="auto">
        <polygon points="-1,0 -3,3 3,0 -3,-3" fill={theme.colors.primaryElement} />
      </marker>
    );
  }

  render() {
    const {delta, from, to} = this.props;

    const curve = {
      x: (from.x + to.x) / 2 + delta.x,
      y: (from.y + to.y) / 2 + delta.y,
    };

    return (
      <g style={{pointerEvents: 'none'}}>
        <path
          d={`M${to.x},${to.y} Q${curve.x},${curve.y} ${from.x},${from.y}`}
          fill="transparent"
          stroke={theme.colors.primaryElement}
          strokeWidth="2"
          strokeLinecap="round"
          markerEnd="url(#open-arrowhead)"
        />
      </g>
    );
  }
}
